module.exports = __webpack_public_path__ + "img/rocket-white.d7c8fd14.png";